import React from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { Button } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
// import "../Certificacion/Curso.css";

interface Props {
    codigo: any;
    arancel: any;
}

export default function PagoModal(props: Props) {
    const {userStore: {user}, modalStore} = useStore();
    return(

        <>
            <div className="modal_pago_cur">
                <div className="modal_pago_head">
                    <h1>Tu Inscripción ha sido realizada con éxito.</h1>
                </div>
                
                <div className="contenido_modal_pago">
                    <p>Presiona el botón <span>"Ver Cuenta Corriente"</span> para que puedas generar tu boleta de pago o realizar el pago en línea a través de tarjeta de crédito o débito</p>

                    <div className="codigo_pago">
                        <h3>Codigo Bancario:</h3>
                        <p>{props.codigo}</p>                              
                        <div className="pago_arancel">
                            <h3>Inversión:</h3>
                            <p>{"Q" + parseFloat(props.arancel).toFixed(2)}</p>
                        </div>
                    </div>

                    <div className="botones_pago_modal">
                        <Button 
                            color="blue" 
                            as={Link} 
                            to={`/home/profile/${user?.userName}/${user?.id}/SaldosPendientes`} exact 
                            onClick={() => {
                                modalStore.closeModal()
                            }}
                        >Ver Cuenta Corriente</Button>
                    </div>
                </div>
                
            </div>
        </>

    )
}